export default __webpack_public_path__ + "./image/b93696e9aed3efaad20c8010e9d63c6b.png";